import { Outlet, useLocation, useNavigate } from "react-router-dom";
import React, { createContext, useEffect, useState, useContext } from "react";
import { Box, Button, Container } from "@mui/material";
import QMentisBreadCrumb from "../../custom-components/QMentisBreadCrumb";
import DownloadIcon from "@mui/icons-material/Download";
import { Typography } from "@mui/material";
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import TestCaseUI from "../../output-components/test-automation/TestCaseImported";
import Feature from "../../output-components/test-automation/FeatureFilesCreated";
import InputForm from "../../output-components/test-automation/PageSource";
import PageClass from "../../output-components/test-automation/PageClass";
import Locators from "../../output-components/test-automation/Locators";
import RobotFile from "./RobotFile";
import StepDefinition from "../../output-components/test-automation/StepDefinition";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { featureFiles, robotFilesService, updateGitHubProjectRobotFramework } from "../../../services/webServices";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import SelectFrameWork from "../input-pages/SelectFrameWork";
import TestEnvironmentForm from "../../output-components/test-automation/TestEnvironment";
import BusinessKeywordDesign from "../../output-components/test-automation/BusinessKeywordDesign";
import MidLevelKeywords from "../../output-components/test-automation/MidLevelKeywords";
import KeywordDesign from "../../output-components/test-automation/KeywordDesign";
import UploadBox from "../input-pages/UploadBox";
import CommonDownload from "../../custom-components/CommonDownload";
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import MessagePopup from "../../popup-components/MessagePopup";
import BrowsePathPopup from "../../output-components/test-automation/BrowsePathPopup";

export const TestCaseFlowDataContext = createContext(null);

const RobotExistingUserStoryExistingProjectOutputPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const [testCaseDetails, setTestCaseDetails] = useState([]);
  // const [featureFiles, setFeatureFiles] = useState("");
  // const [pageSources, setPageSources] = useState("");
  // const [locators, setLocators] = useState({});
  // const [pageClasses, setPageClasses] = useState("");
  // const [stepDefinitions, setstepDefinitions] = useState("");
  // const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);

  const [testCase, setTestCase] = useState({});
  const [testEnvironment, setTestEnviorment] = useState({});
  const [keywordDesign, setKeywordDesign] = useState({});
  // const [showKeywordDesign, setShowKeywordDesign] = useState(false); // New state
  const [midLevelKeywords, setMidLevelKeywords] = useState({});
  const [uploadBox, setUploadBox] = useState({});
  // const [showMidLevelKeywords, setShowMidLevelKeywords] = useState(false); // New state
  const [showInputForm, setShowInputForm] = useState(false);

  const [featureFile, setFeatureFile] = useState("");
  const [pageSource, setPageSource] = useState("");
  const [locator, setLocator] = useState("");
  const [pageClass, setPageClass] = useState("");
  const [robotFile, setRobotFile] = useState("");
  const [RobotFrameworkGenerated, setRobotFrameworkGenerated] = useState({});
  const [responseError, setResponseError] = useState(null);
  // const [loading, setLoading] = useState(false);
  const { setLoadingState } = useContext(LoadingModalContext);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [gitPopup, setGitPopup] = useState(false);
  const [gitCredentials, setGitCredentials] = useState({});
  const [gitPopupMessage, setGitPopupMessage] = useState("Congratulations! Your Robot Framework project has been successfully updated.");
  const [prDetails, setPrDetails] = useState(null);
  const [pageSourceData, setPageSourceData] = useState(false);

  const [isFrameworkConfirmed, setIsFrameworkConfirmed] = useState(false);
  const handleFrameworkConfirm = () => {
    setIsFrameworkConfirmed(true);
  };

  useEffect(() => {
    console.log(location.state?.gitCredentials, "Existing User stroy");
    setTestCase(location.state?.testCaseData || {});
    setTestEnviorment(location.state?.testEnvironmentData || {});
    setKeywordDesign(location.state?.keywordDesignData || {});
    setMidLevelKeywords(location.state?.midLevelKeywordsData || {});
    setUploadBox(location.state?.uploadBoxData || {});
    setPageSource(location.state?.pageSource || "");
    setLocator(location.state?.generatedLocators || {});
    setPageClass(location.state?.generatedPageclassData || "");
    setRobotFile(location.state?.generatedRobotFileData || "");
    setGitCredentials(location.state?.gitCredentials)
  }, [
    location.state?.testCaseData,
    location.state?.testEnvironmentData,
    location.state?.featureFileData,
    location.state?.keywordDesignData,
    location.state?.uploadBoxData,
    location.state?.midLevelKeywordsData,
    location.state?.pageSource,
    location.state?.generatedLocators,
    location.state?.generatedPageclassData,
    location.state?.generatedRobotFileData,
    location.state?.framework,
    location.state?.gitCredentials

  ]);

  const breadCrumbs = [

    // {
    //   title: "Set Test Environment",
    //   status: Object.entries(testEnvironment).length == 0 ? "Completed" : "In Progress",
    // },

    // {
    //   title: "Keyword Design",
    //   status:
    //     Object.keys(keywordDesign).length > 0
    //       ? "Completed"
    //       : "In Progress",

    // },
    // {
    //   title: "Mid-Level Keywords",
    //   status:
    //     // !!midLevelKeywords && midLevelKeywords > 0
    //     Object.keys(midLevelKeywords).length > 0

    //       ? "Completed"
    //       : Object.entries(keywordDesign).length > 0
    //         ? "In Progress"
    //         : "Not Started",
    // },

    {
      title: "Test Case Details",
      status:
        Object.keys(testCase).length > 0
          ? "Completed"

          : "In Progress",
    },

    {
      title: "Introduce SUT",
      status:
        !!pageSource && pageSource !== ""
          ? "Completed"
          : Object.entries(testCase).length > 0
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Locators",
      status:
        Object.keys(locator).length > 0
          ? "Completed"
          : !!pageSource && pageSource !== ""
            ? "In Progress"
            : "Not Started",
    },

    // {
    //   title: "Generate ROBOT File",
    //   status:
    //     !!robotFile && robotFile !== ""
    //       ? "Completed"
    //       : Object.keys(locator).length > 0
    //         ? "In Progress"
    //         : "Not Started",
    // },

  ];

  // const handleGenerateTestCases = async () => {
  //     try {
  //         // Your API call to generate feature files
  //         const generatedFeatureFileResponse = await featureFiles(testCase);
  //         // Make sure to define testCasesData
  //         const generatedFeatureFile = generatedFeatureFileResponse.data;
  //         navigate(location.pathname, { state: { ...location.state, featureFileData: generatedFeatureFile }, replace: true })
  //     } catch (error) {
  //         console.error("Error generating feature files:", error);
  //     } finally {
  //         // setLoading(false);
  //     }
  // };
  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };

  const handleGitHubProject = async () => {
    console.log("=== handleGitHubProject called ===");
    console.log("Current testCase state:", testCase);
    console.log("Current locator state:", locator);

    // Validate that we have the required data
    if (!gitCredentials || Object.keys(gitCredentials).length === 0) {
      console.error("Git credentials validation failed - empty or missing");
      setPopupMessage("GitHub credentials are missing. Please go back to the framework selection page and configure your GitHub settings through the proper flow.");
      setPopupOpen(true);
      return;
    }

    // Validate specific git credential fields
    if (!gitCredentials.token) {
      console.error("Missing git credential fields:", gitCredentials);
      setPopupMessage("GitHub credentials are incomplete. Missing username, token, or repository name. Please go back and configure your GitHub settings properly.");
      setPopupOpen(true);
      return;
    }

    if (!testCase || Object.keys(testCase).length === 0) {
      setPopupMessage("Test case data is missing. Please upload test case details first.");
      setPopupOpen(true);
      return;
    }

    if (!locator || Object.keys(locator).length === 0) {
      setPopupMessage("Locator data is missing. Please generate locators first.");
      setPopupOpen(true);
      return;
    }

    // setLoading(true);
    let fake;

    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 0.001;
        if (progress >= 97 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 97) progress = 97;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Committing Changes to GitHub",
      progress: 0,
    });

    fake = startProgress(setLoadingState);
    try {
      // Extract test cases from testCase data
      const extractTestCases = (testCaseData) => {
        if (Array.isArray(testCaseData)) {
          return testCaseData;
        }

        // If testCaseData is an object, create a comprehensive test case description
        if (testCaseData && typeof testCaseData === 'object') {
          const formattedTestCase = [];

          // Test Case ID
          if (testCaseData['Test Case ID']) {
            formattedTestCase.push(`Test Case ID: ${testCaseData['Test Case ID']}`);
          }

          // Test Case Title
          if (testCaseData['Test Case Title']) {
            formattedTestCase.push(`Test Case Title: ${testCaseData['Test Case Title']}`);
          }

          // Test Objective
          if (testCaseData['Test Objective']) {
            formattedTestCase.push(`Test Objective: ${testCaseData['Test Objective']}`);
          }

          // Priority
          if (testCaseData['Priority']) {
            formattedTestCase.push(`Priority: ${testCaseData['Priority']}`);
          }

          // Module Name
          if (testCaseData['Module Name']) {
            formattedTestCase.push(`Module Name: ${testCaseData['Module Name']}`);
          }

          // Type
          if (testCaseData['Type']) {
            formattedTestCase.push(`Type: ${testCaseData['Type']}`);
          }

          // Preconditions
          if (testCaseData['Preconditions']) {
            if (Array.isArray(testCaseData['Preconditions'])) {
              formattedTestCase.push(`Preconditions: ${testCaseData['Preconditions'].join(', ')}`);
            } else {
              formattedTestCase.push(`Preconditions: ${testCaseData['Preconditions']}`);
            }
          }

          // Test Steps
          if (testCaseData['Test Steps'] && Array.isArray(testCaseData['Test Steps'])) {
            formattedTestCase.push(`Test Steps:`);
            testCaseData['Test Steps'].forEach((step, index) => {
              formattedTestCase.push(`  ${index + 1}. ${step}`);
            });
          }

          // Expected Result
          if (testCaseData['Expected Result']) {
            formattedTestCase.push(`Expected Result: ${testCaseData['Expected Result']}`);
          }

          // Post-conditions
          if (testCaseData['Post-conditions']) {
            if (Array.isArray(testCaseData['Post-conditions'])) {
              formattedTestCase.push(`Post-conditions: ${testCaseData['Post-conditions'].join(', ')}`);
            } else {
              formattedTestCase.push(`Post-conditions: ${testCaseData['Post-conditions']}`);
            }
          }

          // Test Data
          if (testCaseData['Test Data (if applicable)']) {
            formattedTestCase.push(`Test Data: ${testCaseData['Test Data (if applicable)']}`);
          }

          // Remarks
          if (testCaseData['Remarks']) {
            formattedTestCase.push(`Remarks: ${testCaseData['Remarks']}`);
          }

          // Sub Module (if exists)
          if (testCaseData['Sub Module']) {
            formattedTestCase.push(`Sub Module: ${testCaseData['Sub Module']}`);
          }

          // Scenario ID (if exists)
          if (testCaseData['Scenario ID']) {
            formattedTestCase.push(`Scenario ID: ${testCaseData['Scenario ID']}`);
          }

          // Return the formatted test case as a single string or fall back to basic extraction
          if (formattedTestCase.length > 0) {
            return [formattedTestCase.join('\n')];
          }
        }

        // Fallback for other formats or if no structured data found
        const testCases = [];

        // Check for common test case properties (fallback)
        if (testCaseData.testCases && Array.isArray(testCaseData.testCases)) {
          return testCaseData.testCases;
        }

        // Basic extraction as fallback
        if (testCaseData.testCaseName || testCaseData.name || testCaseData.title) {
          testCases.push(testCaseData.testCaseName || testCaseData.name || testCaseData.title);
        }

        if (testCaseData.description || testCaseData.scenario) {
          testCases.push(testCaseData.description || testCaseData.scenario);
        }

        return testCases.length > 0 ? testCases : ['Robot Framework automated test case'];
      };

      // Prepare the data to send to the web service according to backend expectations
      const requestData = {
        repositoryUrl: gitCredentials.repositoryUrl,
        token: gitCredentials.token,

        // testCases: extractTestCases(testCase),
        testCases: testCase,
        locators: locator,
        featureName: featureFile ? 'Feature file automation' : 'Test automation',
        baseBranch: gitCredentials.selectedBranch || 'main',
        reviewerEmails: gitCredentials.reviewerEmail ? [gitCredentials.reviewerEmail] : [],
        frameworkType: "KDD-Robot"
      };

      console.log("Sending data to GitHub service:", requestData);
      console.log("Git credentials:", gitCredentials);
      console.log("Test case data:", testCase);
      console.log("Locator data:", locator);
      console.log("Extracted test cases:", requestData.testCases);

      // Call the web service
      const response = await updateGitHubProjectRobotFramework(requestData);

      console.log("GitHub service response:", response);

      // Store PR details for display
      if (response.data && response.data.success) {
        setPrDetails({
          pullRequestUrl: response.data.data?.pullRequestUrl || null,
          repository: response.data.data?.repository || `${gitCredentials.username}/${gitCredentials.repoName}`,
          branch: response.data.data?.branch || null,
          filesCreated: response.data.data?.filesCreated || 0,
          executionTime: response.data.executionTime || null
        });

        setGitPopupMessage("Congratulations! Your Robot Framework project has been successfully updated.");
      } else {
        setPrDetails(null);
        setGitPopupMessage("Project updated successfully!");
      }
      setGitPopup(true);

    } catch (error) {
      console.error("Error updating GitHub project:", error);
      const errorMsg = error?.response?.data?.Error || error?.response?.data?.message || "An error occurred while updating the GitHub project. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      // setLoading(false);
      setLoadingState({ open: false, message: "", progress: null });

    }
  }

  const handlePageSource = () => {
    navigate(location.pathname, {
      state: { ...location.state, pageSource: "" },
      replace: true,
    });
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  }

  // const locatorsNextButton = {
  //   label: "Generate ROBOT File",
  //   onClick: handleRobotFiles,

  //   variant: "contained",
  //   startIcon: <GenerateButton />,
  //   sx: { float: "right" },
  // };
  const updateGithubProject = {
    label: "Update Github Project",
    onClick: handleGitHubProject,

    variant: "contained",
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  };
  const robotFrameworkDownloadButton = {
    label: "Download",
    onClick: handleDownloadClick,
    variant: "text",
    startIcon: <SaveAltRoundedIcon />,
    sx: { textTransform: "none", float: 'right' },
  };

  const formatTestPlan = (testPlanData) => {
    const formattedTestPlan = {};
    Object.entries(testPlanData).map(([key, value]) => {
      // console.log(typeof value);
      // console.log(value)
      if (Array.isArray(value)) {
        return (formattedTestPlan[key] = flattenArray(value));
      }
      if (!!value && typeof value === "object") {
        return (formattedTestPlan[key] = flattenObject(value));
      }
      return (formattedTestPlan[key] = value);
    });
    // console.log(formattedTestPlan)
    return formattedTestPlan;
  };
  const handleCloseDownload = () => {
    setDownloadOpen(false);
  }
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
        zIndex: 999999999
      }}
    >
      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0",
            width: "100%", // Adjust width when sidebar expands
            zIndex: 1000,
            bgcolor: "white",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            overflow: "hidden",
            padding: "0 8px",
            transition: "width 0.3s ease-in-out", // Smooth transition effect
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{
              height: "auto",
              minHeight: "68px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              overflow: "hidden",
              wordBreak: "break-word",
              textOverflow: "ellipsis",
              flexShrink: 1,
              width: "100%",
              maxWidth: "100%",
              transition: "max-width 0.3s ease-in-out", // Adjust when sidebar expands
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            height: "80vh",
            minHeight: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              margin: "10px auto",
              "& > *:not(:last-child)": {
                marginBottom: "16px", // Adds margin between components but not after the last one
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={0.1}
            >
              <Box display="flex" alignItems="center" mb={0.1}>
                <AutomateIcon style={{ marginRight: 4 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  sx={{ mt: 0.5 }}
                >
                  Generate automated test scripts
                </Typography>
              </Box>
              <FullscreenToggle />
            </Box>
            {/* JAVA SELENIUM COMPONENTS */}




            {/* {Object.entries(testEnvironment).length === 0 && (
              <TestEnvironmentForm
                testEnvironmentData={testEnvironment}
                setTestEnviorment={setTestEnviorment}
                keywordDesignData={keywordDesign}
                framework={location.state?.framework}
                confirmed={confirmed}
                setConfirmed={setConfirmed}
              />
            )} */}

            {/* //KEY WORD DESIGN */}
            {/* {Object.entries(keywordDesign).length !== 0 && (
              <KeywordDesign
                keywordDesignData={keywordDesign}
                setKeywordDesign={setKeywordDesign}
                keyWordDesignCodeEditorData={midLevelKeywords.keyWordCodeEditorData}
              />
            )} */}

            {/* {Object.entries(midLevelKeywords).length !== 0 && midLevelKeywords && (
              <MidLevelKeywords
                midLevelKeywordsData={midLevelKeywords}
                setMidLevelKeywords={setMidLevelKeywords}
                keywordDesignData={keywordDesign}  //Pass keywordDesign data here
                setUploadBox={setUploadBox}
              />
            )} */}

            {/* {
            Object.entries(uploadBox).length > 0 && uploadBox &&
            ( */}
            <UploadBox
              uploadBoxData={uploadBox}
              setUploadBox={setUploadBox}
              setTestCase={setTestCase}
              robotFrameworkDownloadButton={robotFrameworkDownloadButton}
            />
            {/* )} */}

            {Object.entries(testCase).length > 0 && (
              <TestCaseUI testCase={testCase} testCaseData={testCase} setTestCase={setTestCase} robotFrameworkDownloadButton={robotFrameworkDownloadButton} />
            )}



            {showInputForm && (
              <InputForm
                setPageSource={setPageSource} // Pass the necessary props to InputForm
              />
            )}

            {!!featureFile && featureFile !== "" && <Feature featureFile={featureFile} setFeatureFile={setFeatureFile} />}
            {Object.entries(testCase).length > 0 && (
              <InputForm setPageSource={setPageSource} setShowInputForm={setShowInputForm} />
            )}
            {Object.entries(locator).length > 0 && (
              <Locators
                locator={locator}
                setLocator={setLocator}
                locatorsNextButton={updateGithubProject}
              />
            )}
            {/* {!!robotFile && robotFile !== "" && (
              <RobotFile
                robotFile={robotFile}
                setRobotFile={setRobotFile}
                testCases={testCase}
                locator={locator}
                setLocator={setLocator}
                midLevelKeywordsData={midLevelKeywords}
                keywordDesignData={keywordDesign} />
            )} */}
            {/* {!!robotFile && robotFile !== "" && (
            <RobotFile robotFile={robotFile} setRobotFile={setRobotFile} />
          )} */}


            {/* {!!robotFile && robotFile !== "" && <StepDefinition stepDefinition={stepDefinition} setstepDefinition={setstepDefinition} featureFile={featureFile} pageClass={pageClass} />} */}


          </Box>
        </Box>
        {/* Add padding-top to avoid overlap with the fixed breadcrumb */}
        <Container
          sx={{
            // paddingTop: "50px", // Adjust this value based on the height of the breadcrumb
            width: "100%",
          }}
        >
          {/* <TestCaseFlowDataContext.Provider
            value={{
              testCaseDetails,
              setTestCaseDetails,
              featureFiles,
              setFeatureFiles,
              pageSources,
              setPageSources,
              locators,
              setLocators,
              pageClasses,
              setPageClasses,
              stepDefinitions,
              setstepDefinitions,

            }}
          > */}

          {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
              <Button
                startIcon={<DownloadIcon />}
                color="#80c3d8"
                sx={{ textTransform: "none", marginRight: '15px', color: '#53adcb', border: '2px solid #53adcb', }}
              >
                Upload
              </Button>
            </Box> */}

          {/* </TestCaseFlowDataContext.Provider> */}
        </Container>
      </Box>
      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI
          tools.
        </Typography>
      </Box>
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />
      <BrowsePathPopup
        open={gitPopup}
        handleClose={() => setGitPopup(false)}
        text1={gitPopupMessage}
        prDetails={prDetails}
      />

      <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
        wordData={[
          {
            type: "subParagraphs",
            data: testCase,
          },
        ]}
        serviceName={"Test Case Details"}
        serviceResponse={formatTestPlan(testCase)}
        documents={['xls', 'csv']}
      />
      <BrowsePathPopup open={popupOpen} handleClose={handleClosePopup} text1={gitPopupMessage} />
    </Box>
  );
};

export default RobotExistingUserStoryExistingProjectOutputPage;
